function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo, useEffect, useMemo } from "react";
import styled, { css, keyframes } from "styled-components";
import useTemp from "astrid-hooks/src/useTemp";
import { secondaryBackground } from "../../../helpers/background";
import ClipContext from "./ClipContext";
import { useRipple } from "./state/ripple";
import { useScope } from "./state/scope";
const move = /*#__PURE__*/keyframes(["from{background-position:0 center;}to{background-position:-200px center;}"]);
const animation = /*#__PURE__*/css(["animation:", " 2s linear infinite;"], move);
const Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-ywhpwr-0"
})(["", " position:absolute;overflow:hidden;top:6px;bottom:0;left:0;", ""], secondaryBackground, ({
  loading
}) => loading && css(["", " background-image:url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"200\" height=\"100\" viewBox=\"0 0 200 100\"><path fill=\"none\" stroke=\"%23CDE1F1\" stroke-width=\"2\" d=\"M0 50 C 40 10, 60 10, 100 50 C 140 90, 160 90, 200 50\" /></svg>');background-repeat:repeat-x;background-size:200px;"], animation));
const Part = /*#__PURE__*/memo(({
  start,
  stop,
  children,
  ...props
}) => {
  const scope = useScope();
  const ripple = useRipple();
  const [tempStart, setTempStart] = useTemp(start);
  const left = tempStart - scope.start;
  const length = stop - tempStart;
  const right = scope.end - stop;
  const displayLength = Math.max(0, Math.min(scope.length, length, stop - scope.start, scope.end - tempStart));
  const context = useMemo(() => ({
    start: -Math.min(0, left),
    end: length + Math.min(0, right)
  }), [left, length, right]);
  useEffect(() => {
    if (ripple) {
      if (start > ripple[1][0]) {
        setTempStart(start + ripple[2]);
      } else {
        setTempStart(start);
      }
    }
  }, [ripple, setTempStart, start]);
  if (displayLength <= 0) return false;
  const style = {
    left: `${Math.max(0, left / scope.length) * 100}%`,
    width: `${displayLength / scope.length * 100}%`
  };
  return /*#__PURE__*/React.createElement(Root, _extends({
    style: style
  }, props), /*#__PURE__*/React.createElement(ClipContext.Provider, {
    value: context
  }, children));
});
Part.defaultProps = {
  stop: 0,
  start: 0
};
export default Part;
//# sourceMappingURL=Part.js.map